import React from 'react';
import { Piano, Wrench, Award } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Particules flottantes */}
      <div className="floating-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 text-center relative z-10">
        {/* Titre principal avec effet shimmer */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light mb-6 sm:mb-8 animate-slide-up">
          <span className="text-shimmer heading-modern">
            Pianos Buchta
          </span>
        </h1>

        {/* Sous-titre élégant */}
        <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-12 sm:mb-16 max-w-3xl mx-auto animate-slide-up px-4" style={{animationDelay: '0.2s'}}>
          L'exigence du son et du savoir-faire
        </p>

        <p className="text-base sm:text-lg text-gray-400 mb-12 sm:mb-16 max-w-4xl mx-auto animate-slide-up font-light leading-relaxed px-4" style={{animationDelay: '0.3s'}}>
          Depuis Rixheim, Musique Buchta perpétue la tradition du piano en Alsace :
          vente, restauration, location et entretien d'instruments d'exception.
        </p>

        {/* Cartes de présentation avec glassmorphism */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16 px-4">
          {/* Collection Exclusive */}
          <div className="glass-card rounded-2xl p-6 sm:p-8 animate-fade-in-scale interactive-card light-effect relative z-10" style={{animationDelay: '0.4s'}}>
            <div className="mb-4 sm:mb-6">
              <Piano className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 mx-auto animate-glow-pulse" />
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 heading-accent">Collection Sélectionnée</h3>
            <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
              Pianos droits, à queue et numériques, neufs ou d'occasion.
              Chaque instrument est révisé, réglé et garanti, issu de marques prestigieuses.
            </p>
          </div>

          {/* Savoir-Faire Artisanal */}
          <div className="glass-card rounded-2xl p-6 sm:p-8 animate-fade-in-scale interactive-card light-effect relative z-10" style={{animationDelay: '0.6s'}}>
            <div className="mb-4 sm:mb-6">
              <Wrench className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 mx-auto animate-glow-pulse" />
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 heading-accent">Expertise Technique</h3>
            <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
              Jean-Claude Buchta, technicien diplômé, met son expérience au service
              de l'accord et de la restauration de pianos de toutes marques.
            </p>
          </div>

          {/* Excellence & Prestige */}
          <div className="glass-card rounded-2xl p-6 sm:p-8 animate-fade-in-scale interactive-card light-effect relative z-10 sm:col-span-2 md:col-span-1" style={{animationDelay: '0.8s'}}>
            <div className="mb-4 sm:mb-6">
              <Award className="h-10 w-10 sm:h-12 sm:w-12 text-yellow-400 mx-auto animate-glow-pulse" />
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 heading-accent">Qualité & Passion</h3>
            <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
              Préparés dans notre atelier alsacien, nos pianos offrent une justesse
              et un toucher remarquables, pour un son à la hauteur de vos émotions.
            </p>
          </div>
        </div>

      </div>

      {/* Effet de lumière d'ambiance */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20 pointer-events-none"></div>
    </section>
  );
};

export default Hero;